<div
  [attr.data-testid]="testId()"
  [ngClass]="[
    'generic-card',
    cardLevelClass(),
    'rounded-lg',
    'shadow-sm',
    'p-6',
    'flex',
    'flex-col',
    'gap-6',
    'h-full',
    styleClass(),
  ]"
>
  <div class="flex items-center justify-between">
    <h3
      class="text-lg font-semibold truncate flex-1 mr-2 mb-0"
      [pTooltip]="title()"
      tooltipPosition="top"
      [tooltipDisabled]="!title()"
      data-testid="project-title"
    >
      {{ title() }}
    </h3>
    <ng-content select="[card-header]"></ng-content>
  </div>

  <div class="flex-1 min-h-0">
    <ng-content select="[card-body]"></ng-content>
  </div>

  <div class="flex flex-col gap-3">
    <ng-content select="[card-footer]"></ng-content>
    @if (actionLabel()) {
      <button
        pButton
        (click)="onAction()?.()"
        [disabled]="actionDisabled()"
        [class]="buttonClasses()"
        data-testid="card-action-button"
        type="button"
      >
        @if (showActionIconLeft()) {
          <i [class]="actionIcon() + ' p-button-icon p-button-icon-left'"></i>
        }
        <span class="p-button-label">{{ actionLabel() }}</span>
        @if (showActionIconRight()) {
          <i [class]="actionIcon() + ' p-button-icon p-button-icon-right'"></i>
        }
      </button>
    }
  </div>
</div>
